import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
export const ClientPillButton = ({
  id,
  label = '',
  className = '',
  onClick = () => {},
  onBlur = () => {},
  ...rest
}) => {
  return <button id={id} className={`multi-choice--pill-button ${className}`} onClick={onClick} onBlur={onBlur} {...rest}>
      <FontAwesomeIcon className="check--icon" icon={faCheck} />
      {label}
    </button>;
};